import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class EmailAndSms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      business:[],
      formData : {
        mail_host:'',
        mail_port:'',
        mail_username:'',
        mail_password:'',
        mail_from_address:'',
        mail_from_name:'',
        encryption:'',
        netgsm_usercode:'',
        netgsm_password:'',
        netgsm_msgheader:'',
      },
      ksoftData : {
        ksoft_username:'',
        ksoft_password:'',
        invoice_prefix:'',
        earchive_invoice_prefix:'',
        manual_efatura_prefix:'',
        manual_earsiv_prefix:''
      },
      loading:false,
      smsLoading:false,
      ksoftLoading:false,
      isLoad:true,
    }
  }
  componentDidMount() {
    this.getBusinessInfo();
  }

  getBusinessInfo = async () => {

    try {
      const response = await apiCall('business/settings/info', 'get', null);
      const updatedData = { ...this.state.formData };
      const updatedksoftData = { ...this.state.ksoftData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === null ? "" : response[key];
      });
      Object.keys(updatedksoftData).forEach(key => {
        updatedksoftData[key] = response[key] === null ? "" : response[key];
      });

      this.setState({ formData: updatedData,ksoftData:updatedksoftData}, () => {
        this.setState({ isLoad: false });
      });
    } catch (e) {
      this.setState({ isLoad: false });
      console.log(e);
    }
  }

  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState(prevState =>({
      formData: {
        ...prevState.formData,
        [id]:value
    }

    }))
  }
  handleKsoftChange = (e) => {
    const { id, value } = e.target;
    // Prefix alanları için büyük harfe çevir
    const isPrefixField = id.includes('prefix');
    const finalValue = isPrefixField ? value.toUpperCase() : value;
    
    this.setState(prevState =>({
      ksoftData: {
        ...prevState.ksoftData,
        [id]: finalValue
      }
    }))
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({loading:true});
    const {formData} = this.state;
    const businessFormData = new FormData();
    Object.keys(formData).forEach(key => {
        businessFormData.append(key, formData[key]);
    });

    try {
      const response = await apiCall('business/settings/update/','post',businessFormData);
      this.setState({loading:false});
      mainHelper.toastMessage(response.status,response.message);
    }catch (e) {
      this.setState({loading:false});
    }

  }
  handleKsoftSubmit = async (e) => {
    e.preventDefault();
    
    const {ksoftData} = this.state;
    
    // Prefix validasyonu
    const prefixFields = ['invoice_prefix', 'earchive_invoice_prefix', 'manual_efatura_prefix', 'manual_earsiv_prefix'];
    for (const field of prefixFields) {
      const value = ksoftData[field];
      if (value && value.trim().length > 0 && value.trim().length !== 3) {
        mainHelper.toastMessage('error', 'Prefix alanları tam olarak 3 karakter olmalıdır!');
        return;
      }
    }
    
    this.setState({ksoftLoading:true});
    
    // Service ID'yi al
    const user = JSON.parse(localStorage.getItem('user'));
    const serviceId = user?.service_id;
    
    const ksoftFormData = new FormData();
    
    // Sadece prefix alanlarını gönder (username ve password zaten disabled)
    prefixFields.forEach(key => {
      if (ksoftData[key] !== null && ksoftData[key] !== undefined) {
        const value = ksoftData[key].trim();
        ksoftFormData.append(key, value);
      }
    });

    try {
      // Prefix'ler services tablosunda olduğu için business/update endpoint'ini kullanıyoruz
      const response = await apiCall(`business/update/${serviceId}`,'post',ksoftFormData);
      this.setState({ksoftLoading:false});
      mainHelper.toastMessage(response.status, response.message);
      // Verileri yeniden çek
      await this.getBusinessInfo();
    }catch (e) {
      this.setState({ksoftLoading:false});
      const errorMessage = e.response?.data?.message || e.response?.data?.errors || 'Güncelleme sırasında hata oluştu!';
      mainHelper.toastMessage('error', errorMessage);
    }

  }
  handleSmsSubmit = async (e) => {
    e.preventDefault();
    this.setState({smsLoading:true});
    const {formData} = this.state;

    const data = {
      netgsm_usercode:formData.netgsm_usercode,
      netgsm_password:formData.netgsm_password,
      netgsm_msgheader:formData.netgsm_msgheader
    }

    try {
      const response = await apiCall('business/settings/update-getgsm/','post',data);
      this.setState({smsLoading:false});
      mainHelper.toastMessage(response.status,response.message);
    }catch (e) {
      this.setState({smsLoading:false});
    }

  }
  render() {
    const {formData,ksoftData,loading,smsLoading,ksoftLoading} = this.state;
    const {userPermissions} = this.props;
    const userHasUpdateEmailAndSmsInfoPermission = userPermissions.includes('update email and sms');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Email ve Sms Ayarları"
                Breadcrumb={[
                  {name: "Ayarlar", navigate: ""},
                  {name: "Entegrasyon Hesapları", navigate: ""},
                ]}
            />

              <div className="row clearfix">
                <div className="col-lg-6 col-md-12">
                  <div className="card">
                    <form onSubmit={this.handleSubmit}>
                      <div className="body">
                        <h6>E-Posta Ayarları</h6>
                        <div className="form-group">
                          <label htmlFor="mail_host" className="font-weight-bold text-cyan">
                            Mail Host
                          </label>
                          <input
                              id="mail_host"
                              className="form-control"
                              placeholder="Mail Host"
                              type="text"
                              value={formData.mail_host || ''}
                              onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="mail_port" className="font-weight-bold text-cyan">
                            Mail Port
                          </label>
                          <input
                              id="mail_port"
                              className="form-control"
                              placeholder="Mail Port"
                              type="number"
                              value={formData.mail_port || ''}
                              onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="mail_port" className="font-weight-bold text-cyan">
                            Şifreleme
                          </label>
                          <input
                              id="encryption"
                              className="form-control"
                              placeholder="Şifreleme"
                              type="text"
                              value={formData.encryption || ''}
                              onChange={this.handleChange}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="mail_username" className="font-weight-bold text-cyan">
                            Mail Kullanıcı Adı
                          </label>
                          <input
                              id="mail_username"
                              type="email"
                              className="form-control"
                              placeholder="Mail Kullanıcı Adı"
                              value={formData.mail_username || ''}
                              onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="mail_password" className="font-weight-bold text-cyan">
                            Mail Şifre
                          </label>
                          <input
                              id="mail_password"
                              className="form-control"
                              type="text"
                              placeholder="Mail Şifre"
                              value={formData.mail_password || ''}
                              onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="mail_from_address" className="font-weight-bold text-cyan">
                            Gönderen Mail Adresi
                          </label>
                          <input
                              id="mail_from_address"
                              className="form-control"
                              placeholder="Gönderen Mail Adresi"
                              type="email"
                              value={formData.mail_from_address || ''}
                              onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="mail_from_name" className="font-weight-bold text-cyan">
                            Gönderen Adı
                          </label>
                          <input
                              id="mail_from_name"
                              className="form-control"
                              placeholder="Gönderen Adı"
                              type="text"
                              value={formData.mail_from_name || ''}
                              onChange={this.handleChange}
                          />
                        </div>

                      </div>
                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {loading ? (
                                    <button className="btn btn-outline-primary btn-block" disabled={true}
                                            style={{textAlign: "-webkit-center"}}>
                                      Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                      color="#268bd2"></ReactLoading>
                                    </button>
                                ) :
                                <button disabled={!userHasUpdateEmailAndSmsInfoPermission}
                                        className="btn btn-outline-primary btn-block" type="submit">
                                  Güncelle
                                </button>}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="card">
                    <form onSubmit={this.handleSmsSubmit}>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <h6>Sms Ayarları</h6>
                            <div className="form-group">
                              <label htmlFor="netgsm_usercode" className="font-weight-bold text-cyan">
                                Netgsm Kullanıcı Kodu(USERCODE)
                              </label>
                              <input
                                  id="netgsm_usercode"
                                  className="form-control"
                                  type="text"
                                  placeholder="Netgsm Kullanıcı Kodu(USERCODE)"
                                  value={formData.netgsm_usercode || ''}
                                  onChange={this.handleChange}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="netgsm_password" className="font-weight-bold text-cyan">
                                Netgsm Şifre
                              </label>
                              <input
                                  id="netgsm_password"
                                  className="form-control"
                                  type="text"
                                  placeholder="Netgsm Şifre"
                                  value={formData.netgsm_password || ''}
                                  onChange={this.handleChange}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="netgsm_msgheader" className="font-weight-bold text-cyan">
                                Netgsm Mesaj Başlığı(MSGHEADER)
                              </label>
                              <input
                                  id="netgsm_msgheader"
                                  className="form-control"
                                  type="text"
                                  placeholder="Netgsm Mesaj Başlığı(MSGHEADER)"
                                  value={formData.netgsm_msgheader || ''}
                                  onChange={this.handleChange}
                              />
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {smsLoading ? (
                                    <button className="btn btn-outline-primary btn-block" disabled={true}
                                            style={{textAlign: "-webkit-center"}}>
                                      Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                      color="#268bd2"></ReactLoading>
                                    </button>
                                ) :
                                <button disabled={!userHasUpdateEmailAndSmsInfoPermission}
                                        className="btn btn-outline-primary btn-block" type="submit">
                                  Güncelle
                                </button>}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="card">
                    <form onSubmit={this.handleKsoftSubmit}>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <h6>Fatura Hesap Bilgileri <small>(Servicezone tarafından doldurulacaktır.)</small></h6>
                            <div className="form-group">
                              <label htmlFor="ksoft_username" className="font-weight-bold text-cyan">
                                Kullanıcı Adı
                              </label>
                              <input
                                  id="ksoft_username"
                                  className="form-control"
                                  type="text"
                                  disabled={true}
                                  placeholder="Kullanıcı Adı"
                                  value={ksoftData.ksoft_username || ''}
                                  onChange={this.handleKsoftChange}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="ksoft_password" className="font-weight-bold text-cyan">
                                Şifre
                              </label>
                              <input
                                  id="ksoft_password"
                                  className="form-control"
                                  type="text"
                                  disabled={true}
                                  placeholder="Şifre"
                                  value={ksoftData.ksoft_password || ''}
                                  onChange={this.handleKsoftChange}
                              />
                            </div>
                          </div>
                        </div>
                        
                        <hr />
                        
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <h6>Fatura Prefix Ayarları <small>(Fatura numaraları için kullanılır)</small></h6>
                            
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="invoice_prefix" className="font-weight-bold text-cyan">
                                    E-Fatura Prefix'i (3 karakter)
                                  </label>
                                  <input
                                      id="invoice_prefix"
                                      className="form-control"
                                      type="text"
                                      maxLength="3"
                                      placeholder="Örn: SRV"
                                      value={ksoftData.invoice_prefix || ''}
                                      onChange={this.handleKsoftChange}
                                      style={{ textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '2px' }}
                                      pattern="[A-Z]{3}"
                                      title="Tam olarak 3 büyük harf giriniz"
                                  />
                                  <small className="form-text text-muted">
                                    Servis işlemlerinden oluşan E-Fatura prefix'i
                                  </small>
                                </div>
                              </div>
                              
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="earchive_invoice_prefix" className="font-weight-bold text-cyan">
                                    E-Arşiv Prefix'i (3 karakter)
                                  </label>
                                  <input
                                      id="earchive_invoice_prefix"
                                      className="form-control"
                                      type="text"
                                      maxLength="3"
                                      placeholder="Örn: ARS"
                                      value={ksoftData.earchive_invoice_prefix || ''}
                                      onChange={this.handleKsoftChange}
                                      style={{ textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '2px' }}
                                      pattern="[A-Z]{3}"
                                      title="Tam olarak 3 büyük harf giriniz"
                                  />
                                  <small className="form-text text-muted">
                                    Servis işlemlerinden oluşan E-Arşiv prefix'i
                                  </small>
                                </div>
                              </div>
                            </div>
                            
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="manual_efatura_prefix" className="font-weight-bold text-cyan">
                                    Manuel E-Fatura Prefix'i (3 karakter)
                                  </label>
                                  <input
                                      id="manual_efatura_prefix"
                                      className="form-control"
                                      type="text"
                                      maxLength="3"
                                      placeholder="Örn: MEF"
                                      value={ksoftData.manual_efatura_prefix || ''}
                                      onChange={this.handleKsoftChange}
                                      style={{ textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '2px' }}
                                      pattern="[A-Z]{3}"
                                      title="Tam olarak 3 büyük harf giriniz"
                                  />
                                  <small className="form-text text-muted">
                                    Manuel oluşturulan E-Fatura prefix'i (Default: MEF)
                                  </small>
                                </div>
                              </div>
                              
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="manual_earsiv_prefix" className="font-weight-bold text-cyan">
                                    Manuel E-Arşiv Prefix'i (3 karakter)
                                  </label>
                                  <input
                                      id="manual_earsiv_prefix"
                                      className="form-control"
                                      type="text"
                                      maxLength="3"
                                      placeholder="Örn: MEA"
                                      value={ksoftData.manual_earsiv_prefix || ''}
                                      onChange={this.handleKsoftChange}
                                      style={{ textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '2px' }}
                                      pattern="[A-Z]{3}"
                                      title="Tam olarak 3 büyük harf giriniz"
                                  />
                                  <small className="form-text text-muted">
                                    Manuel oluşturulan E-Arşiv prefix'i (Default: MEA)
                                  </small>
                                </div>
                              </div>
                            </div>
                            
                            <div className="alert alert-info">
                              <i className="icon-info"></i>
                              <strong>Bilgi:</strong> Prefix'ler 3 karakter olmalı ve büyük harf kullanılmalıdır. 
                              Boş bırakılırsa sistem default değerleri kullanır.
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {ksoftLoading ? (
                                    <button className="btn btn-outline-primary btn-block" disabled={true}
                                            style={{textAlign: "-webkit-center"}}>
                                      Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                      color="#268bd2"></ReactLoading>
                                    </button>
                                ) :
                                <button disabled={!userHasUpdateEmailAndSmsInfoPermission}
                                        className="btn btn-outline-primary btn-block" type="submit">
                                  Güncelle
                                </button>}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(EmailAndSms)));
